import * as React from 'react';

import classify from 'src/utils/classify';

import css from './one-line.css';
import borderlessCss from './borderless.css';


export type OneLineInputProps = UnstyledOneLineInputProps & {
  classNames?: undefined;
};

export function OneLineTextInput(props: OneLineInputProps) {
  // @ts-expect-error - TS2698 - Spread types may only be created from object types.
  return <UnstyledOneLineInput {...props} classNames={css} />;
}
export default OneLineTextInput;

export function BorderlessTextInput(props: OneLineInputProps) {
  // @ts-expect-error - TS2698 - Spread types may only be created from object types.
  return <UnstyledOneLineInput {...props} classNames={borderlessCss} />;
}

export type UnstyledOneLineInputProps = {
  classNames: Readonly<{
    input: string;
    withPrefix: string;
    withError: string;
    small?: string;
    medium?: string;
  }>;
  className?: string;
  autoFocus?: boolean;
  prefix?: React.ReactNode;
  onChange?: (arg1: React.ChangeEvent<HTMLInputElement>) => unknown;
  onBlur?: (arg1: React.SyntheticEvent<HTMLInputElement>) => unknown;
  onKeyDown?: (arg1: React.KeyboardEvent<HTMLInputElement>) => unknown;
  value?: string;
  defaultValue?: string;
  placeholder?: string | null | undefined;
  maxLength?: number;
  error?: string | null | undefined;
  type?: 'text' | 'email' | 'date' | 'time' | 'number';
  size?: 'medium' | 'small';
  disabled?: unknown;
  min?: number;
  max?: number;
};

export function UnstyledOneLineInput({
  type = 'text',
  classNames,
  className,
  autoFocus,
  prefix,
  error,
  size = 'medium',
  ...props
}: UnstyledOneLineInputProps): React.ReactElement<React.ComponentProps<'div'>> {
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const ref = React.useRef();
  React.useEffect(() => {
    if (autoFocus) {
      // @ts-expect-error - TS2339 - Property 'focus' does not exist on type '{}'.
      ref.current?.focus();
    }
  }, [autoFocus]);

  return (
    <div
      className={classify(
        classNames.input,
        className,
        prefix ? classNames.withPrefix : null,
        error && classNames.withError,
        classNames[size],
      )}
      onClick={() => {
        // @ts-expect-error - TS2339 - Property 'focus' does not exist on type '{}'.
        ref.current?.focus();
      }}
    >
      {prefix}
      {/* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'Ref<HTMLInputElement> | undefined'. */}
      <input type={type} ref={ref} autoComplete="new-password" {...props} />
    </div>
  );
}

export function OneLineErrorInput({
  error,
  // @ts-expect-error - TS2700 - Rest types may only be created from object types.
  ...props
}: OneLineInputProps): React.ReactElement<React.ComponentProps<'div'>> {
  return (
    <div className={css.container}>
      {/* @ts-expect-error - TS2786 - 'OneLineTextInput' cannot be used as a JSX component. */}
      <OneLineTextInput {...props} error={error} />
      <div className={css.errorMessage}>{error}</div>
    </div>
  );
}
